import React from "react";
import Typist from "react-typist";
import "../../App";
import Seo from "../Seo";

const BecomeDeveloperHeader = () => {
  const heroStyles = {
    container: {
      marginBottom: 0,
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      paddingTop: "100px",
      paddingBottom: "60px"
    },
    content: {
      maxWidth: "800px",
      margin: "0 auto",
      padding: "0 20px"
    },
    heading: {
      fontSize: "clamp(2rem, 6vw, 3.5rem)",
      fontWeight: "700",
      letterSpacing: "-0.02em",
      lineHeight: "1.2",
      marginBottom: "24px",
      textShadow: "0 4px 30px rgba(0, 0, 0, 0.3)"
    }
  };

  return (
    <div>
      <Seo
        title="Become a Developer — Join the Team | NeedForGeeks"
        description="Join NeedForGeeks. We're always looking for talented developers and technicians in New York. Apply to become part of the team."
        path="/become-a-developer"
      />
      <div
        id="developerHeader"
        className="jumbotron jumbotron-fluid bg-transparent bgstyle text-light"
        style={heroStyles.container}
      >
        <div style={heroStyles.content} className="container container-fluid text-center">
          <h1 style={heroStyles.heading}>Become A Developer</h1>
          <Typist
            className="lead"
            cursor={{ show: true, blink: true, element: '|', hideWhenDone: true }}
            avgTypingDelay={30}
          >
            Contact us with your info and attach a resume! We'll get back to you if we think you are a good fit.
          </Typist>
        </div>
      </div>
    </div>
  );
};

export default BecomeDeveloperHeader;
